module.exports = __webpack_public_path__ + "img/success.32a6e615.png";